import * as Yup from 'yup'
import { urlPatternWithHttps } from './constants'
import { websiteValidationCheckMessage } from './messagesContants'
import TemplateDesignFormFormikValidationSchema from './TemplateDesignFormFormikValidationSchema'
const ListingCardFormikValidationSchema: Yup.AnyObjectSchema =
  Yup.object().shape({
    listingCardData: Yup.object().shape({
      name: Yup.string()
        .required('Layout name cannot be empty')
        .matches(/^(?!\d*$).+$/, 'Layout name cannot be only numbers'),
      product: Yup.array().of(
        Yup.object().shape({
          url: Yup.string()
            .matches(urlPatternWithHttps, websiteValidationCheckMessage)
            .required('The URL field cannot be empty'),
        })
      ),
      template: TemplateDesignFormFormikValidationSchema,
    }),
  })

export default ListingCardFormikValidationSchema
